<template>
  <section class="main-content">
    <div v-for="item in dapps" class="main-container">
      <p class="title">{{ item.type }}</p>
      <div class="dapp-container">
        <div v-for="dapp in item.list" class="dapp">
          <div class="dapp-title-container">
            <div class="dapp-logo-container">
              <img :src="require(`../assets/img/logo/${dapp['icon_name']}.png`)">
            </div>
            <div class="dapp-title-content" @click="toUrl(dapp.url)">
              <div class="dapp-title-content-inner">
                <div class="dapp-title-block">
                  <p class="dapp-title">{{ dapp.title }}</p>
                  <div class="enter pic-full"></div>
                </div>
                <p class="dapp-url">{{ dapp.url }}</p>
              </div>
            </div>
          </div>
          <div class="add-button-container" @click="addDApp(dapp)">
            <div class="add-button">{{ $t('add') }}</div>
          </div>
        </div>
        <div v-for="emptyDapp in 3" class="dapp empty-dapp"></div>
      </div>
    </div>
  </section>
</template>

<script>
const tp = require('tp-js-sdk')
export default {
  name: "main-content",
  props: {
    dapps: {
      type: Array
    }
  },
  methods: {
    addDApp(dapp) {
      if (this.device === 'pc') {
        this.$emit('selectDApp', dapp)
      } else {
        const params = {
          ...dapp,
          protocol: "TIP-001",
          protocol_version: "1.0",
          icon_url: `https://raw.githubusercontent.com/dappcom/dapps/main/src/assets/img/logo/${dapp['icon_name']}.png`
        }
        delete params['icon_name']
        if (this.isTP) {
          tp.addDAppToDiscover(params).then(res=>{}).catch(err=>{})
        } else {
          location.href = 'tpdiscover://add?params=' + encodeURI(JSON.stringify(params))
        }
      }
    },
    toUrl(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="less">
@media screen and (min-width: 1000px) {
  .main-content {
    margin-left: 275px;
    width: calc(100vw - 325px);
    margin-top: 50px;
  }
}
@media screen and (max-width: 1000px) and (min-width: 767px) {
  .main-content {
    margin-left: 200px;
    width: calc(100vw - 250px);
    margin-top: 33px;
  }
}
@media screen and (min-width: 767px) {
  .main-content {
    margin-bottom: 20px;
    max-height: 87vh;
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .main-container {
      margin-bottom: 0.2rem;
      padding: 0.32rem 0.2rem 0.32rem 0.32rem;
      background-color: #fbfcff;
      box-shadow: 0 0.02rem 0.04rem 0 rgba(39,97,231,0.03);
      border-radius: 0.32rem;
      font-size: 0;

      .title {
        padding: 0.11rem 0.37rem;
        display: inline-block;
        background: white;
        border-radius: 0.16rem;
        box-shadow: 0 0.02rem 0.04rem 0 rgba(39,97,231,0.03);
        font-size: 0.22rem;
        font-weight: bold;
        font-family: PingFangSC, PingFangSC-Medium;
      }

      .dapp-container {
        display: flex;
        flex-wrap: wrap;

        .dapp {
          width: 2.68rem;
          margin-right: 0.12rem;
          margin-top: 0.12rem;
          background-color: white;
          box-shadow: 0 0.02rem 0.04rem 0 rgba(39,97,231,0.07);
          border-radius: 0.16rem;
          min-width: 140px;
          padding: 0.2rem;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          border: 0.02rem solid transparent;
          display: inline-block;

          &:hover {
            border-color: #2761e7;
          }

          .dapp-title-container {
            display: flex;

            .dapp-logo-container {
              width: 18%;

              img {
                width: 100%;
                border-radius: 0.16rem;
              }
            }

            .dapp-title-content {
              margin-left: 0.12rem;
              width: 80%;
              word-break: break-all;
              cursor: pointer;

              .dapp-title-content-inner {
                width: 125%;
                transform: scale(0.8);
                transform-origin: 0 0;
                .dapp-title-block {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  .dapp-title {
                    font-size: 0.225rem;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: bold;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                  }
                  .enter {
                    width: 0.1rem;
                    height: 0.15rem;
                    background-image: url("../assets/img/pc/right.png");
                  }
                }
                .dapp-url {
                  font-size: 0.175rem;
                  transform-origin: 0 0;
                  color: #999999;
                  font-weight: 400;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                }
              }

              &:hover {
                .dapp-title-content-inner {
                  .dapp-title-block {
                    .dapp-title {
                      color: #2761e7;
                    }
                    .enter {
                      background-image: url("../assets/img/pc/right_active.png");
                    }
                  }
                }
              }
            }
          }
          .add-button-container {
            margin-top: 0.1rem;
            border-radius: 0.12rem;
            border: 1px solid #d7d7d7;
            padding-top: 0.13rem;
            padding-bottom: 0.11rem;
            text-align: center;
            font-family: PingFangSC, PingFangSC-Medium;
            cursor: pointer;
            .add-button {
              font-size: 0.175rem;
              transform: scale(0.8);
              width: 125%;
              text-align: center;
              transform-origin: 0 0;
            }

            &:hover {
              border-color: #2761e7;
              background-color: #2761e7;
              .add-button {
                color: white;
              }
            }
          }
        }

        .empty-dapp {
          visibility: hidden;
          padding: 0;
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .main-content {
    margin: 0.24rem 0.32rem;

    .main-container {
      font-size: 0;

      &:not(:first-child) {
        margin-top: 0.5rem;
      }

      .title {
        padding: 0.1rem 0.42rem;
        margin-bottom: 0.24rem;
        display: inline-block;
        background: white;
        border-radius: 0.16rem;
        box-shadow: 0 0.02rem 0.04rem 0 rgba(39,97,231,0.03);
        font-size: 0.32rem;
        font-weight: bold;
        font-family: PingFangSC, PingFangSC-Medium;
      }

      .dapp-container {

        .dapp {
          margin-bottom: 0.2rem;
          background-color: white;
          border-radius: 0.24rem;
          padding: 0.28rem 0.27rem 0.28rem 0.24rem;
          display: flex;
          justify-content: space-between;

          .dapp-title-container {
            display: flex;

            .dapp-logo-container {
              width: 0.78rem;

              img {
                width: 100%;
                border-radius: 0.2rem;
              }
            }

            .dapp-title-content {
              margin-left: 0.2rem;
              width: 3.3rem;
              word-break: break-all;

              .dapp-title-content-inner {
                padding-top: 0.05rem;
                .dapp-title-block {
                  display: flex;
                  align-items: center;
                  .dapp-title {
                    font-size: 0.28rem;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: bold;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                  }
                  .enter {
                    margin-left: 0.28rem;
                    width: 0.1rem;
                    height: 0.15rem;
                    background-image: url("../assets/img/mobile/right.png");
                  }
                }
                .dapp-url {
                  font-size: 0.2rem;
                  transform-origin: 0 0;
                  color: #999999;
                  font-weight: 400;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                }
              }
            }
          }
          .add-button-container {
            border-radius: 0.12rem;
            border: 1px solid #d7d7d7;
            text-align: center;
            display: flex;
            align-items: center;
            height: 0.88rem;
            font-family: PingFangSC, PingFangSC-Medium;
            .add-button {
              width: 1.94rem;
              font-size: 0.22rem;
              text-align: center;
            }
          }
        }

        .empty-dapp {
          display: none;
        }
      }
    }
  }
}
</style>
